<template>
  <div class="animated fadeInRight ecommerce">
    <el-card class="ibox">
      <div slot="header" class="flex justify-between">
        <div>{{ $t('auditOpenShop.title') }}</div>
      </div>
      <div class="">
        <el-table :data="auditOpenShopInfo.shops" style="width: 100%" border stripe size="medium">
          <el-table-column prop="shopLogo" :label="$t('auditOpenShop.shopLogo')" align="center" width="120">
            <template slot-scope="scope">
              <el-image style="width: 60px; height: 60px; border-radius: 5px;" :src="scope.row.shopLogo"
                fit="cover"></el-image>
            </template>
          </el-table-column>
          <el-table-column prop="shopName" :label="$t('auditOpenShop.shopName')" align="center"></el-table-column>
          <el-table-column prop="shopTypeName" :label="$t('auditOpenShop.shopType')" align="center"></el-table-column>
          <el-table-column prop="storeName" :label="$t('auditOpenShop.storeName')" align="center"></el-table-column>
          <el-table-column prop="storeAddress" :label="$t('auditOpenShop.storeAddress')"
            align="center"></el-table-column>
          <el-table-column prop="storeTel" :label="$t('auditOpenShop.storeTel')" align="center"></el-table-column>
          <el-table-column prop="stateName" :label="$t('auditOpenShop.state')" align="center"></el-table-column>
          <el-table-column :label="$t('auditOpenShop.operation')" align="center" width="200">
            <template slot-scope="scope">
              <el-button size="mini" @click="_openAuditDetail(scope.row)">
                {{ $t('auditOpenShop.viewDetail') }}
              </el-button>
              <el-button v-if="scope.row.canAuditOpenShop" type="primary" size="mini"
                @click="_openAuditDetail(scope.row, true)">
                {{ $t('auditOpenShop.audit') }}
              </el-button>
            </template>
          </el-table-column>
        </el-table>

        <el-pagination @current-change="handleCurrentChange" :current-page="auditOpenShopInfo.conditions.page"
          :page-size="DEFAULT_ROWS" layout="total, prev, pager, next" :total="auditOpenShopInfo.total"
          class="pagination"></el-pagination>
      </div>
    </el-card>

  </div>
</template>

<script>
import { queryNeedAuditShop } from '@/api/admin/auditOpenShopApi'

export default {
  name: 'AuditOpenShop',
  data() {
    return {
      DEFAULT_PAGE: 1,
      DEFAULT_ROWS: 10,
      auditOpenShopInfo: {
        shops: [],
        total: 0,
        records: 1,
        conditions: {
          page: 1,
          row: 10,
          AuditOpenShopsId: '',
          userName: '',
          auditLink: ''
        }
      }
    }
  },
  created() {
    this._listAuditOpenShops(this.DEFAULT_PAGE, this.DEFAULT_ROWS)
  },
  methods: {
    handleCurrentChange(val) {
      this._listAuditOpenShops(val, this.DEFAULT_ROWS)
    },
    async _listAuditOpenShops(page, rows) {
      this.auditOpenShopInfo.conditions.page = page
      this.auditOpenShopInfo.conditions.row = rows

      try {
        const res = await queryNeedAuditShop(this.auditOpenShopInfo.conditions)
        this.auditOpenShopInfo.total = res.total
        this.auditOpenShopInfo.records = res.records
        this.auditOpenShopInfo.shops = res.data
      } catch (error) {
        console.error('请求失败:', error)
      }
    },
    _openAuditDetail(auditOrder, isAudit = false) {
      this.$router.push({
        path: '/pages/shop/shopAuditDetail',
        query: {
          from: 'admin',
          shopId: auditOrder.shopId,
          storeId: auditOrder.storeId,
          audit: isAudit ? '1' : '0'
        }
      })
    }
  }
}
</script>

<style scoped>
.ibox {
  margin-bottom: 20px;
}

.pagination {
  margin-top: 20px;
  text-align: right;
}
</style>